import jQuery from "jquery";
window.jQuery = jQuery;
$ = jQuery;

import moment from "moment-timezone";
import countdown from "countdown";
import "../lib/chosen/chosen.jquery";

countdown.setLabels(
    hpaTranslatedtext.timeZoneAndCountDown.countdown_label_singular, // " millisecond| sec| min| hour| day| week| month| year| decade| century| millennium"
    hpaTranslatedtext.timeZoneAndCountDown.countdown_label_plural, // " milliseconds| secs| mins| hours| days| weeks| months| years| decades| centuries| millennia"
    hpaTranslatedtext.timeZoneAndCountDown.countdown_label_last, // " and "
    hpaTranslatedtext.timeZoneAndCountDown.countdown_label_separator, // ", "
   
    function(n) {
        return n.toString();
    }
);

import "moment-countdown";

$(function() {
    // countdown timer
    var $countDown = $(".js-countdown");
    if ($countDown.length) {
        var timeFrom = $countDown.data("timefrom");
        if (timeFrom.length) {
            var timezone = $countDown.data("timezone");
            if (!timezone) {
                timezone = "Pacific/Auckland";
            }
            var baseTimeZone = moment.tz(timeFrom, timezone);
            var localTimeZone = moment.tz.guess();
            var m = moment.tz(baseTimeZone, localTimeZone);
            // Guessing timezone things
            var countDownTimer = setInterval(function() {
                var cd = m.countdown();
                var now = moment().tz(localTimeZone);
                if (m.diff(now, "seconds") > 0) {
                    $countDown.html(cd.toString());
                } else {
                    clearInterval(countDownTimer);
                    $countDown.html("");
                    $countDown.parent(".js-starts").text(hpaTranslatedtext.timeZoneAndCountDown.liveNow); // Live Now
                }
            }, 1000);
        }
    }

    var $webinarChatSalesBoxCountdown = $(".webinarChatSalesBox-countdown");
    if ($webinarChatSalesBoxCountdown.length) {
        var timeFrom = $webinarChatSalesBoxCountdown.data("timefrom");
        if (timeFrom.length) {
            var timezone = $webinarChatSalesBoxCountdown.data("timezone");
            if (!timezone) {
                timezone = "Pacific/Auckland";
            }
            var baseTimeZone = moment.tz(timeFrom, timezone);
            var localTimeZone = moment.tz.guess();
            var salesBoxMoment = moment.tz(baseTimeZone, localTimeZone);
            salesBoxMoment.add(72, 'hours');
            // Guessing timezone things
            var salesBoxCountdownTimer = setInterval(function() {
                var cd = salesBoxMoment.countdown();
                var now = moment().tz(localTimeZone);
                if (salesBoxMoment.diff(now, "seconds") > 0) {
                    $webinarChatSalesBoxCountdown.html(cd.toString());
                } else {
                    clearInterval(salesBoxCountdownTimer);
                    $webinarChatSalesBoxCountdown.html(hpaTranslatedtext.timeZoneAndCountDown.offerHasExpired); // Offer has expired
                }
            }, 1000);
        }
    }

    // timezone picker,
    //
    var guessTimeZone = moment.tz.guess();
    if (guessTimeZone) {
        var $timeZoneOption = $('#TimeZoneConverter option[value="' + guessTimeZone + '"]');
        if ($timeZoneOption.length) {
            $timeZoneOption
                .attr("selected", true)
                .siblings()
                .removeAttr("selected");
            $("#TimeZoneConverter").trigger("chosen:updated");
        }
    }

    $("#TimeZoneConverter")
        .chosen()
        .change(function(event, params) {
            changeTimeBasedOnTimeZone(params.selected);
        });

    function changeTimeBasedOnTimeZone(localTimeZone) {
        var $timezoneCovert = $(".js-timezoneconvert");

        if ($timezoneCovert.length < 1) {
            return;
        }

        if (!localTimeZone) {
            localTimeZone = moment.tz.guess();
        }

        $timezoneCovert.each(function() {
            var $el = $(this);
            var timeFrom = $el.data("ustime");
            var dateTimeFormat = $el.data("format");
            var $timezoneDisplay = $(".js-timezoneDisplay");
            if (!dateTimeFormat) {
                dateTimeFormat = "Do MMM YYYY, h:mma";
            }
            var USTimeFrom = moment.tz(timeFrom, "America/Los_Angeles");
            var m = moment.tz(USTimeFrom, localTimeZone);
            $el.text(m.format(dateTimeFormat));
            $timezoneDisplay.text(" (" + m.zoneName() + ")");
        });
    }
    //

    changeTimeBasedOnTimeZone();
});



// WEBPACK FOOTER //
// ./js/modules/timeZoneAndCountDown.js